import "./reports.css";

const Reports = () => (
    <div className="row d-flex pt-3 pb-3">
      <div className="col">Reports</div>
    </div>
  );
  
  export default Reports;
